var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "#2D5049",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3906 0.9375L7.0625 13.2656L2.5625 8.71875C2.32812 8.53125 1.95312 8.53125 1.76562 8.71875L0.40625 10.0781C0.21875 10.2656 0.21875 10.6406 0.40625 10.875L6.6875 17.1094C6.92187 17.3438 7.25 17.3438 7.48437 17.1094L21.5469 3.04688C21.7344 2.85938 21.7344 2.48438 21.5469 2.25L20.1875 0.9375C20 0.703125 19.625 0.703125 19.3906 0.9375Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.68fd0dc5c74b354f62d5e0acb1ea9f08.svg";
export { ForwardRef as ReactComponent };